module.exports = __webpack_public_path__ + "img/det3.18e988c1.png";